import { render, staticRenderFns } from "./TenantSwitchDialog.vue?vue&type=template&id=0273c0d0&"
import script from "./TenantSwitchDialog.vue?vue&type=script&lang=js&"
export * from "./TenantSwitchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports